import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { SaveCancel } from "../components/PrimaryButton"; 

const UpdateSageBCPopup = ({ open, onConfirm, onCancel, saving = false }) => {
  const { t } = useTranslation();
  const [newCode, setNewCode] = useState("");

  useEffect(() => {
    if (open) {
      setNewCode("");
    }
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[1050]">
      <div className="w-auto h-auto bg-white shadow-[0px_20px_80px_#00000011] rounded-[12px] p-6">

        {/* Message */}
        <div className="text-center py-4 px-12 text-[#36495C] font-medium text-[20px]" style={{ fontFamily: "Montserrat" }}>
          <p>{t("placeholder.updateSageCode")}</p>
        </div>

        {/* Input Field */}
        <input
          type="text"
          placeholder="N° de BC"
          className="text-[#043F88] text-[20px] font-medium text-center border border-gray-300 rounded-md px-2 py-1 w-full"
          value={newCode}
          onChange={(e) => setNewCode(e.target.value)}
        />

        {/* Buttons */}
        <div className="flex justify-center gap-4 mt-6">
          <SaveCancel
            onCancelClick={onCancel}
            onSaveClick={() => onConfirm(newCode)}
            saving={saving}
          />
        </div>
      </div>
    </div>
  );
};

export default UpdateSageBCPopup;
